import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MigrainePage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Migraine</h1>
        <section className="mb-8">
          <p>Migraine is a neurological condition characterized by severe, recurring headaches often accompanied by other symptoms. Our natural therapies focus on reducing frequency and intensity of migraines, managing triggers, and improving overall neurological health through gentle, holistic approaches.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal changes</li>
            <li>Stress and anxiety</li>
            <li>Dietary triggers</li>
            <li>Sleep disturbances</li>
            <li>Environmental factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Severe headache</li>
            <li>Nausea and vomiting</li>
            <li>Sensitivity to light and sound</li>
            <li>Visual disturbances</li>
            <li>Dizziness</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use pain-relieving herbs, stress management techniques, and lifestyle modifications to naturally treat migraines. Our approach focuses on reducing frequency and intensity of attacks, managing triggers, and improving overall neurological health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural pain relief</li>
            <li>Reduced attack frequency</li>
            <li>No harsh side effects</li>
            <li>Long-term management</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain regular sleep schedule</li>
            <li>Identify and avoid triggers</li>
            <li>Practice stress management</li>
            <li>Regular exercise</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure migraines?</strong>
            <p>A: While migraines may not be completely curable, our treatments can effectively reduce frequency and intensity of attacks.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of migraines.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see results?</strong>
            <p>A: Many patients notice improvement within a few weeks of starting treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from migraines—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default MigrainePage; 